/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import { get, findIndex } from 'lodash';
import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';
import RichTextNotesHeader from './RichTextNotesHeader';
import CopyAssetLink from '../../../../components/CopyAssetLink';
import ChooseOption from './ChooseOption';
import VerbRadioInput from '../../../../../shared/components/formComponents/inputs/VerbRadioInput';

class ChooseOneQuizSectionItem extends Component {
    static propTypes = {
        contentValues: PropTypes.object.isRequired,
        memberReference: PropTypes.string,
        assetLinkOptions: PropTypes.array,
        changeFormValue: PropTypes.func.isRequired,
        isGlobalSectionItem: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {
            correctAnswerId: ''
        };
    }

    UNSAFE_componentWillMount() {
        this._setInitialCorrectId(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.memberReference && nextProps.memberReference !== this.props.memberReference) {
            this._setInitialCorrectId(nextProps);
        }
    }

    _setInitialCorrectId = (props) => {
        const {
            contentValues: { options = [] }
        } = props;

        options.forEach((option) => {
            if (option.isCorrect === true) {
                this.setState({ correctAnswerId: option.id });
            }
        });
    };

    _renderCorrectAnswerRadioButtons = () => {
        const { contentValues, isGlobalSectionItem } = this.props;
        const { correctAnswerId } = this.state;

        const options = get(contentValues, 'options', []);

        const radioOptions = options.map((option) => ({ value: option.id }));

        return (
            <VerbRadioInput
                answerSubmitted={isGlobalSectionItem}
                staticLabel={'Is Correct?'}
                value={correctAnswerId}
                onChange={this.handleRadioChange.bind(this)}
                options={radioOptions}
            />
        );
    };

    handleRadioChange = (value) => {
        const {
            memberReference,
            changeFormValue,
            contentValues: { options = [] }
        } = this.props;
        const previousCorrectAnswerIndex = findIndex(options, (option) => option.isCorrect === true);
        const newCorrectAnswerIndex = findIndex(options, (option) => option.id === value);

        if (previousCorrectAnswerIndex > -1) {
            changeFormValue({
                field: memberReference
                    ? `${memberReference}.content.options.${previousCorrectAnswerIndex}.isCorrect`
                    : `content.options.${previousCorrectAnswerIndex}.isCorrect`,
                value: false
            });
        }

        this.setState({ correctAnswerId: value });

        changeFormValue({
            field: memberReference
                ? `${memberReference}.content.options.${newCorrectAnswerIndex}.isCorrect`
                : `content.options.${newCorrectAnswerIndex}.isCorrect`,
            value: true
        });
    };

    render() {
        const { memberReference, contentValues, isGlobalSectionItem } = this.props;
        return (
            <div className={'choose-one-quiz-section-item'}>
                <div className={'row'}>
                    <div className={'col-7'}>
                        <Field
                            name={memberReference ? `${memberReference}.content.description` : 'content.description'}
                            label={'Description'}
                            className={'description'}
                            placeholder={'Enter a description'}
                            component={VerbRichTextEditor}
                            rows={3}
                            readOnly={isGlobalSectionItem}
                        />
                    </div>
                    <div className={'col-5 mt-4'}>
                        <RichTextNotesHeader />
                        <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
                    </div>
                </div>
                <div className={'row choice-container'}>
                    <div className={'quiz-choices col-10'}>
                        <FieldArray
                            name={memberReference ? `${memberReference}.content.options` : 'content.options'}
                            contentValues={contentValues}
                            isQuizType={true}
                            disabled={isGlobalSectionItem}
                            component={ChooseOption}
                        />
                    </div>
                    <div className={'correct-choice-buttons col-2'}>{this._renderCorrectAnswerRadioButtons()}</div>
                </div>
                <div className={'row'}>
                    <div className={'col-7'}>
                        <Field
                            name={
                                memberReference ? `${memberReference}.content.answerFeedback` : 'content.answerFeedback'
                            }
                            label={'Answer Feedback'}
                            placeholder={'Enter answer feedback here.'}
                            component={VerbRichTextEditor}
                            rows={3}
                            readOnly={isGlobalSectionItem}
                            className={'feedback-input'}
                        />
                    </div>
                    <div className={'col-5 mt-4'}>
                        <RichTextNotesHeader />
                        <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
                    </div>
                </div>
            </div>
        );
    }
}

export default ChooseOneQuizSectionItem;
